module.exports = __webpack_public_path__ + "img/vanMedia.970b40fa.png";